import api from '~services/axios';

export default {
  // 登录-暂时没做
  apiLogin: params => api.post('/', params),

  // 退出登录-2021年05月13日15:37:39 本次加上
  apiLogout: params => api.get('/api/quit', { params }),

  // 测试人员测试接口
  apiTest: params => api.get('/api/common/monitor', { params }),
};
